import React from "react";
import { AiOutlineLinkedin } from "react-icons/ai";
import { FaGithub } from "react-icons/fa";
import hero from "../assets/images/hero.png";
import ReactGA from 'react-ga4';
const Hero = () => {
	const handleButtonClick = () => {
  ReactGA.event({                                   category: 'Button',
    action: 'click_header_contact_button',
    label: 'Go to contact from header'
  });
};
  return (
    <section
      id="home"
      className="min-h-screen flex py-10 md:flex-row flex-col items-center"
    >
      <div className="flex-1 flex items-center justify-center h-full">
        <img src={hero} alt="" className="md:w-11/12 h-full object-cover" />
      </div>
      <div className="flex-1">
        <div className="md:text-left text-center">
          <h1 className="md:text-4xl text-2xl md:leading-normal leading-10 text-white font-bold">
            <span className="text-cyan-600 md:text-6xl text-5xl">
              Hello!
              <br />
            </span>
            I'm Benjamin Dekens
          </h1>
          <h4 className="md:text-2xl text-lg md:leading-normal leading-5 mt-4 font-bold text-gray-600">
            Frontend Developer
          </h4>
          <a href="#contact">
	  <button onClick={handleButtonClick} className="btn-primary mt-8 w-36">
            Contact Me
	  </button>
          </a>
          <div className="mt-8 text-3xl flex items-center md:justify-start justify-center gap-5">
            <p className="text-xl">social_</p>
            <a
              href="https://www.linkedin.com/in/benjamindekens/en"
              target="_blank"
              rel="noreferrer"
              className="text-gray-600 hover:text-white cursor-pointer "
            >
              <AiOutlineLinkedin />
            </a>
            <a
              href="https://github.com/ben-2"
              target="_blank"
              rel="noreferrer"
              className="text-gray-600 hover:text-white cursor-pointer "
            >
              <FaGithub />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
